






















import { Component, Vue, Prop } from 'vue-property-decorator';
import OptionsData from '@/ts/OptionsData';

@Component
export default class MobileOptionsSelectedOptionsItem extends Vue {
    @Prop() public item!: OptionsData;

    constructor() {
        super();
    }

    get getTempData(): any {
        return this.$store.getters['Options/allOptions'];
    }
}
